import { Box, Switch, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';

interface SmsRoleTogglesProps {
  isLoading: boolean;
  disabled?: boolean;
  smsEnabledForAdmins: boolean;
  smsEnabledForProgramManagers: boolean;
  smsEnabledForActivityLeaders: boolean;
  onAdminToggle: () => void;
  onProgramManagerToggle: () => void;
  onActivityLeaderToggle: () => void;
}

export const SmsRoleToggles = ({
  isLoading,
  disabled,
  smsEnabledForAdmins,
  smsEnabledForProgramManagers,
  smsEnabledForActivityLeaders: _unusedSmsEnabledForActivityLeaders,
  onAdminToggle,
  onProgramManagerToggle,
  onActivityLeaderToggle: _unusedOnActivityLeaderToggle,
}: SmsRoleTogglesProps) => {
  if (isLoading) {
    return (
      <Box>
        <Skeleton variant='text' width='60%' height={20} style={{ marginBottom: '8px' }} />
        <Skeleton variant='text' width='80%' height={14} style={{ marginBottom: '16px' }} />
        <Box display='flex' flexDirection='column'>
          <Skeleton variant='rect' width='100%' height={40} style={{ marginBottom: '8px' }} />
          <Skeleton variant='rect' width='100%' height={40} style={{ marginBottom: '8px' }} />
          <Skeleton variant='rect' width='100%' height={40} />
        </Box>
      </Box>
    );
  }

  return (
    <Box mt={2}>
      <Typography
        style={{
          fontWeight: 500,
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        Enable SMS for:
      </Typography>
      <Typography variant={'body2'} style={{ fontSize: '14px', color: '#808080', paddingBottom: '1em' }}>
        {'Selected roles will be able to send SMS messages to volunteers'}
      </Typography>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={smsEnabledForAdmins}
          onChange={onAdminToggle}
          color='primary'
          disabled={disabled}
          inputProps={{ 'aria-label': 'enable SMS for admins' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              color: '#333',
            }}
          >
            Admins
          </Typography>
        </Box>
      </Box>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={smsEnabledForProgramManagers}
          onChange={onProgramManagerToggle}
          color='primary'
          disabled={disabled}
          inputProps={{ 'aria-label': 'enable SMS for program managers' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              color: '#333',
            }}
          >
            Program Managers
          </Typography>
        </Box>
      </Box>
      {/* Activity Leader SMS Toggle hidden per user request
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={smsEnabledForActivityLeaders}
          onChange={onActivityLeaderToggle}
          color='primary'
          disabled={disabled}
          inputProps={{ 'aria-label': 'enable SMS for activity leaders' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              color: '#333',
            }}
          >
            Activity Leaders
          </Typography>
        </Box>
      </Box>
      */}
    </Box>
  );
};
